import { styled } from '@mui/material';

export const ListEntryContainer = styled('div')(({ theme, isLast }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1.75, 2),
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  gap: theme.spacing(2),
}));

export const EmployeeInfoContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  flex: '0 0 200px', // Fixed width for employee info
  minWidth: '200px',
}));

export const ShiftsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: '1 1 auto', // Take available space
  textAlign: 'center',
  justifyContent: 'center',
}));

export const StatusContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: '0 0 250px', // Fixed width for status
  minWidth: '250px',
  justifyContent: 'flex-end',
}));
